import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import businessModelActions from '../actions/businessModel';
import {MERCHANT_OF_RECORD} from '../utils/constants';

function getPreferredBusinessModel(store, action) {
    const { systemId, advertiserId } = action.payload;
    const { isPmis = false } = store.getState().pmisBusinessModelSwitch;

    const queryParams = new URLSearchParams({ systemId, isPmis });
    if (typeof advertiserId !== 'undefined') {
        queryParams.append('advertiserId', advertiserId);
    }

    request.get(`/${config.url_prefix}/api/getPreferredBusinessModel?${queryParams.toString()}`)
        .end((error, response) => {
            if (error) {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(businessModelActions.alertError('ipmob.internal.server.error'));
                return;
            }

            try {
                const res = JSON.parse(response.text);
                const businessModelType = res.businessModel;

                if (isPmis && businessModelType === MERCHANT_OF_RECORD.SUPPLIER) {
                    // Keep the load overlay up through the app-state transition so the confirmation
                    // page never flashes before the ineligible redirect; InformationPageContainer
                    // takes over overlay management once it mounts for the INELIGIBLE state.
                    store.dispatch(actions.changeAppState('INELIGIBLE'));
                } else {
                    store.dispatch(actions.enableLoadOverLay(false));
                    store.dispatch(businessModelActions.getPreferredBusinessModelSuccess(businessModelType));
                }
            } catch (exp) {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(businessModelActions.alertError('ipmob.error.process.request'));
            }
        });
}

export default getPreferredBusinessModel;
